import { render, staticRenderFns } from "./ContactRequestNotifySomeone.vue?vue&type=template&id=222ec8ec"
import script from "./ContactRequestNotifySomeone.vue?vue&type=script&lang=js"
export * from "./ContactRequestNotifySomeone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports